import aiInventoryList from './aiInventoryList'
import assetInventoryList from './assetInventoryList'
import auditList from './auditList'
import changesManagementList from './changesManagementList'
import committeeList from './committeeList'
import companyFragilities from './companyFragilities'
import companyList from './companyList'
import companySupplierQuestionnairesReceivedList from './companySupplierQuestionnairesReceivedList'
import companySuppliers from './companySuppliers'
import complaintList from './complaintList'
import consentList from './consentList'
import consentReceiptList from './consentReceiptList'
import cookiesList from './cookiesList'
import dashboardList from './dashboardList'
import dataProcessList from './dataProcessList'
import departmentList from './departmentList'
import diagnosticsList from './diagnosticsList'
import documentTemplateList from './documentTemplateList'
import externalPlatformIntegrationList from './externalPlatformIntegrationList'
import governanceProjectList from './governanceProjectList'
import incidentList from './incidentList'
import lastUpdate from './lastUpdate'
import marketplaceList from './marketplaceList'
import monitoringManagementKpiList from './monitoringManagementKpiList'
import monitoringManagementNcList from './monitoringManagementNcList'
import monitoringManagementPdcaList from './monitoringManagementPdcaList'
import monitoringManagementPmcList from './monitoringManagementPmcList'
import paymentList from './paymentList'
import privacyByDesignList from './privacyByDesignList'
import privacyPolicyList from './privacyPolicyList'
import privacyPortalThemeList from './privacyPortalThemeList'
import phishingList from './phishingList'
import profileList from './profileList'
import questionnaireList from './questionnaireList'
import ripdList from './ripdList'
import smtpCredentialList from './smtpCredentialList'
import supplierSuggestionsList from './supplierSuggestionsList'
import taskList from './taskList'
import titularTicketList from './titularTicketList'
import trainingList from './trainingList'
import userList from './userList'
import trainningJourneyList from './trainningJourneyList'

const permissionsList = {
  aiInventoryList,
  assetInventoryList,
  auditList,
  changesManagementList,
  committeeList,
  companyFragilities,
  companyList,
  companySupplierQuestionnairesReceivedList,
  companySuppliers,
  complaintList,
  consentList,
  consentReceiptList,
  cookiesList,
  dashboardList,
  dataProcessList,
  departmentList,
  diagnosticsList,
  documentTemplateList,
  externalPlatformIntegrationList,
  governanceProjectList,
  incidentList,
  lastUpdate,
  marketplaceList,
  monitoringManagementKpiList,
  monitoringManagementNcList,
  monitoringManagementPdcaList,
  monitoringManagementPmcList,
  paymentList,
  privacyByDesignList,
  privacyPolicyList,
  privacyPortalThemeList,
  phishingList,
  profileList,
  questionnaireList,
  ripdList,
  smtpCredentialList,
  supplierSuggestionsList,
  taskList,
  titularTicketList,
  trainingList,
  trainningJourneyList,
  userList,
}

export default permissionsList
